import { Injectable } from '@angular/core';

import { SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY, SEARCH_ALL_PARAMS_STATE_KEYS } from '../state/constants';

import { AppStateService } from 'Angular/services/app-state.service';

@Injectable({
    providedIn: 'root',
})
export class SearchAllStateService {
    constructor(private appStateService: AppStateService) {}

    initAppState(): void {
        this.appStateService.setStateSlice(SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(SEARCH_ALL_PARAMS_STATE_KEYS);
        this.appStateService.start();
    }
}
